import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';
import enabledStripeBilling from '../../constants/StripeBilling';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const UserTableHead = enhance(({ order, orderBy, onRequestSort, roles }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell />
        {(roles.isSecretariat || roles.isDeveloper) && (
          <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
            <TableSortLabel
              active={orderBy === 'shopId'}
              direction={order}
              onClick={() => {
                onRequestSort('shopId');
              }}
            >
              店舗ID
            </TableSortLabel>
          </TableCell>
        )}
        <TableCell sortDirection={orderBy === 'menuId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuId'}
            direction={order}
            onClick={() => {
              onRequestSort('menuId');
            }}
          >
            メニューID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuChildType' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuChildType'}
            direction={order}
            onClick={() => {
              onRequestSort('menuChildType');
            }}
          >
            種別
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuCombo' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuCombo'}
            direction={order}
            onClick={() => {
              onRequestSort('menuCombo');
            }}
          >
            回数券無有
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuLimitTotal' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuLimitTotal'}
            direction={order}
            onClick={() => {
              onRequestSort('menuLimitTotal');
            }}
          >
            利用方法
          </TableSortLabel>
        </TableCell>
        {enabledStripeBilling === true && (
          <TableCell>サブスクチケット有無</TableCell>
        )}
        {(roles.isSecretariat || roles.isDeveloper) && (
          <TableCell sortDirection={orderBy === 'groupName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'groupName'}
              direction={order}
              onClick={() => {
                onRequestSort('groupName');
              }}
            >
              運営会社名
            </TableSortLabel>
          </TableCell>
        )}
        <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopName'}
            direction={order}
            onClick={() => {
              onRequestSort('shopName');
            }}
          >
            店舗名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuName'}
            direction={order}
            onClick={() => {
              onRequestSort('menuName');
            }}
          >
            メニュー名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'price' ? order : false}>
          <TableSortLabel
            active={orderBy === 'price'}
            direction={order}
            onClick={() => {
              onRequestSort('price');
            }}
          >
            価格
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            税区分
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'quantity' ? order : false}>
          <TableSortLabel
            active={orderBy === 'quantity'}
            direction={order}
            onClick={() => {
              onRequestSort('quantity');
            }}
          >
            発行枚数
          </TableSortLabel>
        </TableCell>
        <TableCell>利用用途</TableCell>
        <TableCell>&nbsp;&nbsp;&nbsp;表示</TableCell>
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(UserTableHead);
